module.exports = __webpack_public_path__ + "static/media/premium-data.a764e2ed.svg";